module.exports = __webpack_public_path__ + "static/img/requests.271dcc9.svg";